module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-03-4cfa64b4a472f95aa75870be9de08250.jpg";